import React from 'react';
import { Card, CardHeader, CardContent } from '../../components/Card';
import { Button } from '../../components/Button';
import { Briefcase } from 'lucide-react';

export function BusinessSettings() {
  return (
    <div className="max-w-6xl space-y-8 animate-in fade-in">
      {/* Header Card */}
      <div className="flex flex-col sm:flex-row justify-between sm:items-center gap-4 bg-card border border-border p-6 rounded-3xl shadow-sm">
        <div className="flex items-center gap-3">
          <div className="size-10 rounded-2xl bg-primary/10 border border-primary/20 text-primary flex items-center justify-center shrink-0">
            <Briefcase className="size-5" />
          </div>
          <div>
            <h1 className="text-foreground font-display text-page-title tracking-tight">Business Settings</h1>
            <p className="text-xs text-muted-foreground mt-0.5">Manage Offices, Departments, and Designations</p>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <Card className="bg-card/50 hover:bg-card/80 transition-colors cursor-pointer">
          <CardHeader>
            <h2 className="font-display text-section-title">Offices</h2>
            <p className="text-xs text-muted-foreground">Manage physical locations</p>
          </CardHeader>
          <CardContent>
            <Button variant="outline" className="w-full">Configure Offices</Button>
          </CardContent>
        </Card>
        
        <Card className="bg-card/50 hover:bg-card/80 transition-colors cursor-pointer">
          <CardHeader>
            <h2 className="font-display text-section-title">Departments</h2>
            <p className="text-xs text-muted-foreground">Manage org structure</p>
          </CardHeader>
          <CardContent>
            <Button variant="outline" className="w-full">Configure Departments</Button>
          </CardContent>
        </Card>

        <Card className="bg-card/50 hover:bg-card/80 transition-colors cursor-pointer">
          <CardHeader>
            <h2 className="font-display text-section-title">Designations</h2>
            <p className="text-xs text-muted-foreground">Manage job titles</p>
          </CardHeader>
          <CardContent>
            <Button variant="outline" className="w-full">Configure Designations</Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
